import type { FaireProductEntity } from "../../entity_types/product";

export const p_kq4b6yxxqp: FaireProductEntity = {
  token: "p_kq4b6yxxqp",
  type: "product",
  name: "Gnome Grown",
  brandToken: "b_6qajwqdzz3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/97c940707a1c79bda3545a7753e73912d364d9828143aca44063360f051ed87f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d98ed51f49a592058d1713ae90999f5ff773c998e82a21df604ac97b596c87b9.jpeg",
    "https://cdn.faire.com/fastly/523a351fa167cbfccc4fa5e1c4ad1c66e4b4581fe2f51bb5e6b4c43147f429c5.jpeg",
    "https://cdn.faire.com/fastly/f6ca96631fa055e2caaf1b6b0b39620f569ea191e927c890aac317f07a61f74e.jpeg",
    "https://cdn.faire.com/fastly/6ba9179836838bb4a405a0e19ff4cceb0d524cca1e28d94e43475e61916d62fe.jpeg",
  ],
  priceDollars: 18.7,
  description:
    "Designed for grass-lovers, this garden gnome statue has a serious message for the neighbors: Stay off the grass. The hilarious Gnome measures at about 9-inches tall and is the perfect gift for your gnomies.",
  tags: [],
  msrpDollars: 37.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:00.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
